import type { FunctionalComponent } from 'preact';
import { useState } from 'preact/hooks';
import { useStore } from '../store';
import { verifyPromoCode } from '../api/client';

export const PromoCode: FunctionalComponent = () => {
  const { state, dispatch } = useStore();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!state.widget?.enable_promo_codes) return null;
  if (state.discount?.source === 'sponsor') return null;

  async function handleApply() {
    if (!code.trim() || !state.event) return;
    setLoading(true);
    setError(null);
    try {
      const result = await verifyPromoCode(state.event._id, code.trim());
      dispatch({
        type: 'SET_DISCOUNT',
        discount: {
          code: result.code,
          type: result.type,
          value: result.value,
          source: 'promo',
        },
      });
      setCode('');
    } catch (e: any) {
      setError(e.message || 'Invalid promo code');
    } finally {
      setLoading(false);
    }
  }

  if (state.discount) {
    return (
      <div class="mw-promo-applied">
        <div class="mw-discount-badge">
          🏷 {state.discount.code} applied
          <button
            type="button"
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.85rem', marginLeft: '0.25rem' }}
            onClick={() => dispatch({ type: 'SET_DISCOUNT', discount: null })}
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <div class="mw-promo">
      <input
        type="text"
        placeholder="Promo code"
        value={code}
        onInput={(e) => {
          setCode((e.target as HTMLInputElement).value);
          setError(null);
        }}
        onKeyDown={(e) => e.key === 'Enter' && handleApply()}
      />
      <button
        type="button"
        class="mw-btn mw-btn--outline mw-btn--small"
        onClick={handleApply}
        disabled={loading || !code.trim()}
      >
        {loading ? '...' : 'Apply'}
      </button>
      {error && <div class="mw-field-error" style={{ alignSelf: 'center' }}>{error}</div>}
    </div>
  );
};
